import React from 'react';
export function SeoStrip() {
  return <div className="w-full border-b border-white/10 bg-charcoal" data-id="element-163" data-mp="384rmniewi9c0">
      <div className="mx-auto max-w-shell px-5 py-2.5 lg:px-8" data-id="element-164" data-mp="121itwb5pcy9b">
        <p className="mx-auto max-w-[860px] text-center text-[12px] leading-relaxed text-chalk/55 lg:text-[12.5px]" data-id="element-165" data-mp="171f08h1vh1s1">
          Auto repair in Oak Ridge, TN for diagnostics, maintenance,
          electrical, engine, A/C, alignment, transmission, and general repair.
        </p>
      </div>
    </div>;
}